import {setFetchingForView, setMetaProp, setView, setCurrent} from '../../../helpers'

export default {
  setFetchingForView,
  setCurrent,
  setMetaProp,
  setView
}



// WEBPACK FOOTER //
// ./src/store/modules/users/mutations.js